import { ActionEvents } from '@griply/types';
import { useCallback, useRef } from 'react';
import { useCreateLifeAreaMutation } from 'shared/hooks/queries/use-create-life-area-mutation';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { NewLifeArea } from 'shared/types/life-area';

export const useCreateLifeArea = () => {
  const newLifeAreaRef = useRef<NewLifeArea>();

  const track = useTrackEvents();
  const { mutate, mutateAsync, data, error, isPending, isSuccess, reset } =
    useCreateLifeAreaMutation();

  const submit = useCallback(
    async (lifeArea: NewLifeArea) => {
      const newLifeArea = { ...lifeArea, createdAt: new Date() };
      newLifeAreaRef.current = newLifeArea;
      const createdLifeArea = await mutateAsync(newLifeArea);
      track(ActionEvents.LifeAreaCreate, undefined);
      return createdLifeArea;
    },
    [mutateAsync, track],
  );

  const retry = useCallback(() => {
    if (newLifeAreaRef.current) {
      mutate(newLifeAreaRef.current);
    }
  }, [mutate]);

  const resetAll = useCallback(() => {
    reset();
    newLifeAreaRef.current = undefined;
  }, [reset]);

  return {
    submit,
    retry,
    reset: resetAll,
    data,
    error,
    isLoading: isPending,
    isSuccess,
  };
};
